import { render, staticRenderFns } from "./PEI_StudentsABAService.vue?vue&type=template&id=a7e5c15c&"
import script from "./PEI_StudentsABAService.vue?vue&type=script&lang=js&"
export * from "./PEI_StudentsABAService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports